<div class="confirm-leave-popup">
  <h4 class="dialog-title text-center mb-0">
    <span class="material-symbols-outlined"> error </span>
  </h4>

  <div>
    <div mat-dialog-content>
      @if (!data?.showSave) {
        <p> {{'Unsaved changes will be lost. Do you want to discard them?' | translate}}</p>
      }
      @if (data?.showSave) {
        <p> {{'You have unsaved changes. Save them or discard?' | translate}}</p>
      }
    </div>

    <div mat-dialog-actions class="mt-4 p-0">
      <button class="custom-main-btn bg-danger text-white text-center" (click)="onDiscard()">
      {{'Discard' | translate}}</button>
      @if (!data?.showSave) {
        <button class="custom-main-btn" (click)="onStay()">{{'Stay' | translate}}</button>
      }
      @if (data?.showSave) {
        <button class="custom-main-btn" (click)="onSave()">{{'Save' | translate}}</button>
      }
    </div>
  </div>
</div>
